import React, { Component } from 'react';

import PeriodTabs from '../PeriodTabs/PeriodTabs';
import Details from '../Details';
import Config from '../Config';
import Chart from '../Chart';

import './styles.css';
import { Container, Col } from './styles';
import { Skeleton } from '@mui/material';
import { connect } from 'react-redux';

class Period extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldReloadFilters: false,
    };
  }

  render() {
    const { shouldReloadFilters } = this.state;
    const { periodListFetching, comparativeFetching } = this.props;

    const isLoading = periodListFetching || comparativeFetching;

    return (
      <div className="Period__container">
        <Container>
          <Col md9>
            {isLoading && (
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="wave"
                style={{ borderRadius: 4}}
              />
            )}
            <Chart
              className="Period__chart"
              key={`${shouldReloadFilters}chart`}
              isLoading={isLoading}
            />
            <PeriodTabs isLoading={isLoading} />
            <Details isLoading={isLoading} />
          </Col>
          <Col md3>
            {isLoading ? (
              <Skeleton
                variant="rectangular"
                height="572px"
                animation="wave"
                style={{ borderRadius: 4}}
              />
            ) : (
              <Config />
            )}
          </Col>
        </Container>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  periodListFetching: state.dashboardCompleted.periodList.isFetching,
  comparativeFetching: state.dashboardCompleted.comparative.isFetching
});

export default connect(mapStateToProps)(Period);
